import { get } from "../GenericServices";

const WorkProgressSupplier = {
  getSupplierReport: (queryString) => {
    return get(`work-progress-supplier/find?${queryString}`);
  },
  downloadSupplierReportCsv: (queryString) => {
    return get(`work-progress-supplier/export-csv?${queryString}`);
  },
  downloadSupplierReportPdf: (queryString) => {
    return get(`work-progress-supplier/export-pdf?${queryString}`, {}, "arraybuffer"); // To download pdf I must set responseType = arraybuffer
  },
};

export default WorkProgressSupplier;
